const AV_COEF = 0.75

export const Functions = {
    getNextStep(steps, amount) {
        let nextStep = 0;
        steps.every(function(step, index) {
            if(amount >= step.min && amount <= step.max) {
                var x = Math.floor((amount - step.min) / step.increment);
                var prev = step.min + x * step.increment;
                nextStep = step.min + (x + ((prev + (step.increment * AV_COEF) >= amount) ? 1 : 2)) * step.increment;
                return false;
            }
            return true;
        });
        return nextStep;
    }
}
